import React from 'react'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMIONES_RECHAZADOS_EN_BRUTO } from '../../../../../../config/tables'

function TablaCamionesRechazadosEnBrutoView () {
  return (
    <MuiTable id={TABLA_CAMIONES_RECHAZADOS_EN_BRUTO} />
  )
}

export default TablaCamionesRechazadosEnBrutoView
